import {
  Button,
  type ButtonProps,
  EditOutlinedIcon,
  VisibilityOutlinedIcon,
} from '@shared/components';

const ICON_VARIANT_MAP = {
  edit: EditOutlinedIcon,
  view: VisibilityOutlinedIcon,
} as const;

const TEXT_VARIANT_MAP = {
  edit: 'Edit',
  view: 'View',
} as const;

interface BlockedRecordsActionButtonProps extends Omit<ButtonProps, 'variant'> {
  variant: 'edit' | 'view';
}

export default function BlockedRecordsActionButton(
  props: Readonly<BlockedRecordsActionButtonProps>,
) {
  const { variant, onClick, ...restProps } = props;

  const Icon = ICON_VARIANT_MAP[variant];

  return (
    <Button
      variant='outlined'
      color='secondary'
      size='small'
      startIcon={<Icon />}
      sx={{
        minWidth: 'auto',
        maxHeight: 'fit-content',
      }}
      onClick={onClick}
      {...restProps}
    >
      {TEXT_VARIANT_MAP[variant]}
    </Button>
  );
}
